import axios from 'axios';
import { uuid } from 'vue-uuid';

export default {
  async simulate(objeto) {
    const endpoint = process.env.VUE_APP_ENDPOINT_WS + "fiducia_simulate";
    try {
      return await axios.post(endpoint, objeto);
    } catch (error) {
      throw new Error(error.message);
    }
  },

  generateCCB() {
    return uuid.v4();
  },

  generateHashAssinatura() {
    return uuid.v4();
  },

  generateHash() {
    return uuid.v4();
  }
};
